import React from 'react';
import Component from '@/Component';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faBell, faBellSlash } from '@fortawesome/free-solid-svg-icons';
import { withRouter, NavLink } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { _toggleAlarm } from '@/actions/noticeAction'

class Header extends Component {
  
  state = {
    isOpen: false
  }

  toggle(bool) {
    this.setState({
      isOpen: typeof bool === 'boolean' ? bool : !this.state.isOpen
    });
  }

  close() {
    this.toggle(false);
  }

  onClickBell(e) {
    e.preventDefault();
    this.props._toggleAlarm();
  }

  onClickThemes(e) {
    this.props.changeThemes(e.target.id)
  }

  render() {
    const {
      alarmFlag
    } = this.props;

    return (
      <Navbar color="dark" fixed="top" dark expand="md">
        <NavbarBrand href="/">
	        <FontAwesomeIcon icon={faHome} style={{paddingTop: 6}} />  GoGoHome! 언제 집에 가지?
          <FontAwesomeIcon icon={alarmFlag ? faBell : faBellSlash} style={{paddingTop: 6, marginLeft: 10}} onClick={this.onClickBell} />
	      </NavbarBrand>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <NavLink exact to="/" className="nav-link" onClick={this.close}>Main</NavLink>
            </NavItem>
            <NavItem>
              <NavLink exact to="/calendar" className="nav-link" onClick={this.close}>Calendar</NavLink>
            </NavItem>
            <NavItem>
              <NavLink exact to="/changelog" className="nav-link" onClick={this.close}>ChangeLog</NavLink>
            </NavItem>
            <NavItem>
              <NavLink exact to="/todo" className="nav-link" onClick={this.close}>Todo</NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Color Themes
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem id="theme_default" onClick={this.onClickThemes}>
                  Default
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem id="theme_orange" onClick={this.onClickThemes}>
                  Orange
                </DropdownItem>
                <DropdownItem id="theme_green" onClick={this.onClickThemes}>
                  Green
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

export default withRouter(connect(
  state => ({
    alarmFlag: state.notice.alarmFlag
  }),
  {
    _toggleAlarm
  }
)(Header));




// WEBPACK FOOTER //
// ./src/template/components/Header.js